import React from 'react';
import { Assistant } from '@/types';
import { renderAssistantIcon } from '@/utils/RenderAssistantIcon';
import { getIconColorFromAssistant } from '@/utils/colorUtils';

interface SuggestedPromptsProps {
    prompts: string[];
    assistant: Assistant;
    onPromptClick: (prompt: string) => void;
}

export const SuggestedPrompts: React.FC<SuggestedPromptsProps> = ({ prompts, assistant, onPromptClick }) => {
    const primaryColor = getIconColorFromAssistant(assistant.bgGradient, assistant.accentColor, '#6366f1');

    return (
        <div className="grid grid-cols-2 gap-2 w-full mb-2">
            {prompts.map((prompt, index) => (
                <button
                    key={index}
                    onClick={() => onPromptClick(prompt)}
                    className="flex items-center gap-1.5 px-3 sm:px-4 py-2.5 sm:py-2 rounded-3xl border border-gray-500 bg-[#2d2d2d] text-gray-300 text-xs sm:text-sm hover:border-gray-300 hover:text-white transition-colors w-full min-h-[44px] sm:min-h-0 text-left"
                >
                    <span className="flex-shrink-0">
                        {renderAssistantIcon({ assistant, iconColor: primaryColor, size: 'sm' })}
                    </span>
                    {prompt}
                </button>
            ))}
        </div>
    );
};
